import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { changeActiveChoice } from '../../../../../../../reducers/active-choice';
import { useLocation } from 'react-router-dom';
import { extendedGetFromSessionStorage, extendedSetIntoSessionStorage } from '../../../../../../../utils';
import { ApplicationRoutes, SessionStorageKeys } from '../../../../../../constants';

export const useActiveTab = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const activeChoice = useSelector(state => state.activeChoice.activeChoice);

    useEffect(() => {
        // Elke route onder /company hoort bij het Vacatures-overzicht.
        const urlBasedTab = location.pathname.startsWith(ApplicationRoutes.hi5Root) ? 'Vacatures' : undefined;
        const storedActiveChoice = JSON.parse(extendedGetFromSessionStorage(SessionStorageKeys.active_tab));

        if (urlBasedTab) {
            dispatch(changeActiveChoice(urlBasedTab));
        } else if (storedActiveChoice && !activeChoice) {
            dispatch(changeActiveChoice(storedActiveChoice));
        } else if (!activeChoice) {
            dispatch(changeActiveChoice('Vacatures'));
        }
    }, [location.pathname, dispatch, activeChoice]);

    useEffect(() => {
        if (activeChoice) {
            extendedSetIntoSessionStorage(SessionStorageKeys.active_tab, JSON.stringify(activeChoice));
        }
    }, [activeChoice]);

    return activeChoice;
};